import { createFileRoute } from '@tanstack/react-router'
import { HelpLayout } from '@/components/help-center/help-layout'
import { HelpArticleContent } from '@/components/help-center/help-article'

const faqItems = [
  {
    question: 'Does MessageDrafts send messages automatically?',
    answer:
      'No. MessageDrafts opens drafts in your own messaging app so you choose when to send.',
  },
  {
    question: 'Do you store contacts or message content?',
    answer:
      'Contacts are used to prepare drafts and are not stored long-term. Message content is not saved after your session.',
  },
  {
    question: 'How are contact imports handled?',
    answer:
      'You can import via the browser contact picker or upload a CSV file. Both keep you in control of the data.',
  },
  {
    question: 'What permissions are required on iOS and Android?',
    answer:
      'The contact picker requires permission to access contacts. You can revoke it any time in device settings.',
  },
  {
    question: 'What data is stored on the server?',
    answer:
      'MessageDrafts does not store message content. Minimal operational data may be stored if you sign in.',
  },
  {
    question: 'How do I delete my data?',
    answer:
      'If you have an account, you can request deletion from account settings or contact support.',
  },
  {
    question:
      'All you are doing is a fancy way to build links. My brother in law could build this in a weekend.',
    answer:
      "Ok. That’s not really a question. It’s true that there is more than one way to solve this problem. We focus on helping those who don’t want to code and build scripts and just want a simple solution to their problem. Have your brother in law get in touch. We need smart people on our team.",
  },
]

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
}

export const Route = createFileRoute('/_public/app/help/faq')({
  component: FaqPage,
  head: () => ({
    meta: [
      { title: 'FAQ | MessageDrafts Help' },
      {
        name: 'description',
        content:
          'Answers to common questions about MessageDrafts, including privacy and contact imports.',
      },
    ],
    scripts: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(faqSchema),
      },
    ],
  }),
})

function FaqPage() {
  return (
    <HelpLayout
      title="Frequently asked questions"
      description="Quick answers about drafts, imports, and privacy."
    >
      <HelpArticleContent
        slug="faq"
        title="FAQ"
        description="Questions we hear most often about MessageDrafts."
        tags={['faq', 'support']}
        devices={['windows', 'macos', 'linux', 'iphone', 'ipad', 'android']}
      >
        <section className="space-y-5">
          {faqItems.map((item) => (
            <div key={item.question} className="space-y-2">
              <h3 className="text-lg font-semibold text-slate-900">
                {item.question}
              </h3>
              <p>{item.answer}</p>
            </div>
          ))}
        </section>
      </HelpArticleContent>
    </HelpLayout>
  )
}
